// Compiled at 2026-09-18T12:45:23.821Z
// Compiled at 2026-09-18T12:45:23.821Z
// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
export const BranchName = 'master';
import { de, enUS } from 'date-fns/locale'

export const AppModuleId = 'Orders', Languages = { "German": { "isoCode": "de", "shortName": "de", "displayName": "Deutsch" }, "English": { "isoCode": "en-US", "shortName": "en", "displayName": "English" } }, DefaultLanguage = "English", DefaultScreen = ["Orders", "Home"] as [string, string], DateFnsLocales = { de, enUS };
